import React from 'react';
import { Box, Text, UnorderedList, ListItem } from '@chakra-ui/react';

const JobDetailsListSection = ({ title, items }) => (
  <Box py={4} px={{ base: 2, md: 6 }}>
    <Text fontWeight="bold" fontSize={{ base: 'lg', md: 'xl' }} mb={2}>{title}</Text>
    <UnorderedList spacing={2} color="gray.700" fontSize={{ base: 'sm', md: 'md' }}>
      {items.map((item, idx) => (
        <ListItem key={idx}>{item}</ListItem>
      ))}
    </UnorderedList>
  </Box>
);

export default JobDetailsListSection; 